@if (!hideLabel) {
  <div class="label">{{ label }}</div>
}

<div #container>
  <div class="control">
    <textarea
      #input
      type="text"
      [value]="_value"
      (blur)="markAsTouched()"
      (input)="handleInputChange(input.value)"
      rows="1"
      [readonly]="static"
    ></textarea>
    <mat-icon (click)="handleSaveChanges(true)">check</mat-icon>
    <mat-icon (click)="handleSaveChanges(false)">close</mat-icon>
    <div class="suffix">
      @if (firstError && touched) {
        <mat-icon color="warn" [@fadeIn]>error </mat-icon>
      }
    </div>
  </div>

  @if (!hideHintError) {
    @if (!(firstError && touched)) {
      <div class="hint">
        {{ hint }}
      </div>
    }

    @if (firstError && touched) {
      <ng-container [ngTemplateOutlet]="firstError.template"></ng-container>
    }
  }
</div>
